var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave-container"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"wave-bar"},[_c('span',{staticClass:"wave",style:({ transform: `scaleY(${_vm.wave / 100})` })})])]),_c('img',{staticClass:"wave-img",attrs:{"src":require("../../images/microphone.png"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }